import { Dialog, Theme } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { COLORS } from 'shared/constants/COLORS';

const StyledDialog = withStyles((theme: Theme) => ({
  paper: {
    backgroundColor: theme.palette.type === 'dark' ? '#0B1017' : 'unset',
    border: theme.palette.type === 'dark' ? '1px solid' : '2px solid',
    borderColor: COLORS.PRIMARY,
    backgroundImage:
      theme.palette.type === 'dark'
        ? 'linear-gradient(to bottom, #0e1319, #0e1319), linear-gradient(253deg, #d51bff, #00d4ff)'
        : 'linear-gradient(to bottom, #FFFFFF, #FFFFFF), linear-gradient(253deg, #d51bff, #00d4ff)',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '8px !important',
  },
}))(Dialog);

export default StyledDialog;
